import FormattedMessage from 'I18n/components/FormattedMessage';
import { ArtificialIntelligenceEnhancedIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AIReportSummaryHeaderTitle = () => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    alignItems: "center",
    gap: "200",
    children: [/*#__PURE__*/_jsx(ArtificialIntelligenceEnhancedIcon, {
      size: "600",
      color: "fill-accent-magenta-default"
    }), /*#__PURE__*/_jsx(Text, {
      as: "h5",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-enablement.singleReportViewer.AIReportSummary.title"
      })
    }), /*#__PURE__*/_jsx(Flex, {
      flexDirection: "row",
      justifyContent: "end",
      alignItems: "baseline",
      gap: "200",
      children: /*#__PURE__*/_jsx(Badge, {
        use: "beta",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-enablement.platformReport.reportVisualizationInsights.container.beta"
        })
      })
    })]
  });
};